import React
	from 'react';

export const NotificationService = {
	notify,
}
function notify (place, color, msg) {
	var type;
	switch (color) {
		case 1:
			type = "primary";
			break;
		case 2:
			type = "success";
			break;
		case 3:
			type = "danger";
			break;
		case 4:
			type = "warning";
			break;
		case 5:
			type = "info";
			break;
		default:
			type = "primary";
			break;
	}
	var options = {};
	options = {
		place: place,
		message: (
			<div>
				<div>
					{msg}
				</div>
			</div>
		),
		type: type,
		icon: "tim-icons icon-bell-55",
		autoDismiss: 7
	};
	return options;
};